__turbopack_context__.v({
  "slider": "styles-module__G4UCyW__slider",
  "sliderBase": "styles-module__G4UCyW__sliderBase",
  "sliding": "styles-module__G4UCyW__sliding",
});
